import Joi from 'joi';

/**
 * Schema for platform settings validation.
 */
export const platformSettingsSchema = () =>
  Joi.object({
    meteringStartsAt: Joi.string().isoDate().optional().allow(null),
    notifications: Joi.object().unknown(true).optional().allow(null),
  }).unknown();
